import { FC, PropsWithChildren } from "react";
import styles from "./CardGrid.module.scss";
export const CardGrid: FC<PropsWithChildren> = ({ children }) => {
	return <div className={styles.grid}>{children}</div>;
};
